// extracted by mini-css-extract-plugin
export default {"input":"AFX9wllDuFc5PBV7di5k"};